document.addEventListener("DOMContentLoaded", function () {
  // Disable Add to Cart button
  const addToCartButton = document.querySelector("[type='submit'][name='add']");
  if (addToCartButton) {
    addToCartButton.disabled = true;
    addToCartButton.textContent = "Add to cart";
  }

  // Scroll to form on button click
  const scrollToFormButton = document.getElementById("ScrollToFormButton");
  if (scrollToFormButton) {
    scrollToFormButton.addEventListener("click", function () {
      const formHeading = document.querySelector("h2.wbs-pck__heading");
      if (formHeading) {
        let offset = window.innerWidth < 768 ? 150 : 200; // Increase offset for desktop
        const yPosition =
          formHeading.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: yPosition, behavior: "smooth" });
      }
    });
  }

  // Handle Request Quote button click
  const quoteButton = document.getElementById("RequestQuoteButton");
  if (quoteButton) {
    quoteButton.addEventListener("click", function () {
      window.location.href =
        "/pages/request-a-quote?product=" +
        encodeURIComponent("{{ product.title }}");
    });
  }

  // Hide form fields after successful submission
  const form = document.querySelector("form[id^='wbs-pck__form']");
  const successMessage = document.querySelector(
    ".wbs-pck__form-reply--success"
  );

  if (form && successMessage) {
    if (successMessage.textContent.trim() !== "") {
      form.classList.add("wbs-pck__form--submitted");
    }
  }
});
